export function request(id) {
    return {
        type: 'AUDIT_REQUEST',
        id
    };
}

export function error(id, errors) {
    return {
        type: 'AUDIT_ERROR',
        id,
        errors
    };
}

export function finish(id, audit) {
    return (dispatch) => {
        dispatch({
            type: 'AUDIT_FINISH',
            id,
            audit
        })
    }
}
